import { render, staticRenderFns } from "./MemberProfileTab.vue?vue&type=template&id=e6b9c67e&"
import script from "./MemberProfileTab.vue?vue&type=script&lang=js&"
export * from "./MemberProfileTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports